import { takeLatest, all } from "redux-saga/effects";
import API from "../services/Api";
import AppConfig from "../config";

/* ------------- Types ------------- */

import { DossierTypes } from "../redux/DossierRedux";

/* ------------- Sagas ------------- */

import { getDossier, saveDossier } from "./DossierSagas";

/* ------------- Connect Types To Sagas ------------- */

export default function* root() {
  /* ------------- API ------------- */
  let url = AppConfig.apiUrl;

  // The API we use is only used from Sagas, so we create it here and pass along
  // to the sagas which need it.
  const api = yield API.create(url);

  yield all([
    // some sagas receive extra parameters in addition to an action
    takeLatest(DossierTypes.GET_DOSSIER, getDossier, api),
    takeLatest(DossierTypes.SAVE_DOSSIER, saveDossier, api),
  ]);
}
